/* eslint-disable */

export default {
  price: {
    name: {
      ar: "السعر",
      en: "Price",
    },
    secondaryName: { ar: "(ريال سعودي)", en: "(SAR)" },
    placeholder: "الرجاء كتابة السعر...",
    type: "text-numeric",
    webType: "number",
    page: 2,
    order: 2,
    default: undefined,
    graphqlType: "Float",
    range(category = 0) {
      switch (category) {
        case 1:
          return {
            min: 50,
            max: 500000,
          };
        case 3:
          return {
            min: 50000,
            max: 100000000,
          };
        case 2:
          return {
            min: 1000,
            max: 10000000000,
          };
        case 5:
          return {
            min: 1000,
            max: 800000,
          };
        case 4:
          return {
            min: 1000,
            max: 300000,
          };
        case 6:
          return {
            min: 50000,
            max: 15000000,
          };
        case 7:
          return {
            min: 100000,
            max: 2000000000,
          };
        case 9:
          return {
            min: 50000,
            max: 5000000,
          };
        case 13:
          return {
            min: 100,
            max: 350000,
          };
        case 11:
          return {
            min: 1000,
            max: 200000,
          };
        case 10:
          return {
            min: 20000,
            max: 50000000,
          };
        case 8:
          return {
            min: 1000,
            max: 5000000,
          };
        case 12:
          return {
            min: 10000,
            max: 150000000,
          };
        case 16:
          return {
            min: 10000,
            max: 150000000,
          };
        case 15:
          return {
            min: 10000,
            max: 50000000,
          };
        case 19:
          return {
            min: 100,
            max: 50000,
          };
        case 14:
          return {
            min: 1500,
            max: 5000000,
          };
        case 18:
          return {
            min: 100,
            max: 5000,
          };
        case 17:
          return {
            min: 80,
            max: 100000000,
          };
        case 20:
          return {
            min: 1000,
            max: 100000000,
          };
        case 21:
          return {
            min: 50,
            max: 500000,
          };
        case 22:
          return {
            min: 50000,
            max: 15000000,
          };
        case 23:
          return {
            min: 100,
            max: 350000,
          };
        default:
          return {
            min: 50,
            max: 100_000_000,
          };
      }
    },
    validation(category = 0, value) {
      const range = this.range(category);

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال السعر",
            en: "Please enter price",
          },
        };
      }
      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر مناسب",
            en: "Please enter appropriate price",
          },
        };
      }
      if (value > range.max) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر مناسب",
            en: "Please enter appropriate price",
          },
        };
      }

      return {
        error: false,
      };
    },
  },

  rent_period: {
    key: "rent_period",
    name: {
      ar: "مدة الإيجار",
      en: "Rent period",
    },
    type: "taps",
    specialType: "taps",
    webType: "number",
    values: {
      ar: ["غير محدد", "يومي", "شهري", "سنوي"],
      en: ["Not Defined", "Daily", "Monthly", "Yearly"],
    },
    options: [
      { label: "غير محدد", value: 0 },
      { label: "يومي", value: "1" },
      { label: "شهري", value: "2" },
      { label: "سنوي", value: "3" },
    ],
    validation(category, value) {
      if (!value || value === 0 || value > 3) {
        return {
          error: true,
          message: {
            ar: `الرجاء اختيار فترة الإيجار`,
            en: `Please choose rental period`,
          },
        };
      }
      return {
        error: false,
      };
    },

    page: 2,
    order: 2,
    default: 0,
    graphqlType: "Int",
  },
  price_12_payments: {
    optional: true,
    name: {
      ar: "يقبل شهري",
      en: "Monthly",
    },
    secondaryName: { ar: "(ريال سعودي)", en: "(SAR)" },
    placeholder: "ادخل هنا...",
    type: "text-numeric",
    toggle: true,
    webType: "number",
    page: 2,
    order: 2,
    default: undefined,
    graphqlType: "Float",
    range(category = 0) {
      switch (category) {
        case 1:
          return {
            min: 50,
            max: 500000,
          };
        case 3:
          return {
            min: 50000,
            max: 100000000,
          };
        case 2:
          return {
            min: 1000,
            max: 10000000000,
          };
        case 5:
          return {
            min: 1000,
            max: 800000,
          };
        case 4:
          return {
            min: 1000,
            max: 300000,
          };
        case 6:
          return {
            min: 50000,
            max: 15000000,
          };
        case 7:
          return {
            min: 100000,
            max: 2000000000,
          };
        case 9:
          return {
            min: 50000,
            max: 5000000,
          };
        case 13:
          return {
            min: 100,
            max: 350000,
          };
        case 11:
          return {
            min: 1000,
            max: 200000,
          };
        case 10:
          return {
            min: 20000,
            max: 50000000,
          };
        case 8:
          return {
            min: 1000,
            max: 5000000,
          };
        case 12:
          return {
            min: 10000,
            max: 150000000,
          };
        case 16:
          return {
            min: 10000,
            max: 150000000,
          };
        case 15:
          return {
            min: 10000,
            max: 50000000,
          };
        case 19:
          return {
            min: 100,
            max: 50000,
          };
        case 14:
          return {
            min: 1500,
            max: 5000000,
          };
        case 18:
          return {
            min: 100,
            max: 5000,
          };
        case 17:
          return {
            min: 80,
            max: 100000000,
          };
        case 20:
          return {
            min: 1000,
            max: 100000000,
          };
        case 21:
          return {
            min: 50,
            max: 500000,
          };
        case 22:
          return {
            min: 50000,
            max: 15000000,
          };
        case 23:
          return {
            min: 100,
            max: 350000,
          };
        default:
          return {
            min: 100,
            max: 100000000,
          };
      }
    },
    validation(category = 0, value) {
      const range = this.range(category);

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال السعر",
            en: "Please enter price",
          },
        };
      }
      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر مناسب",
            en: "Please enter appropriate price",
          },
        };
      }
      if (value > range.max) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر مناسب",
            en: "Please enter appropriate price",
          },
        };
      }

      return {
        error: false,
      };
    },
  },
  price_4_payments: {
    optional: true,

    name: {
      ar: "يقبل ربع سنوي",
      en: "Quarterly",
    },
    secondaryName: { ar: "(ريال سعودي)", en: "(SAR)" },
    placeholder: "ادخل هنا...",
    type: "text-numeric",
    toggle: true,
    webType: "number",
    page: 2,
    order: 2,
    default: undefined,
    graphqlType: "Float",
    range(category = 0) {
      switch (category) {
        case 1:
          return {
            min: 50,
            max: 500000,
          };
        case 3:
          return {
            min: 50000,
            max: 100000000,
          };
        case 2:
          return {
            min: 1000,
            max: 10000000000,
          };
        case 5:
          return {
            min: 1000,
            max: 800000,
          };
        case 4:
          return {
            min: 1000,
            max: 300000,
          };
        case 6:
          return {
            min: 50000,
            max: 15000000,
          };
        case 7:
          return {
            min: 100000,
            max: 2000000000,
          };
        case 9:
          return {
            min: 50000,
            max: 5000000,
          };
        case 13:
          return {
            min: 100,
            max: 350000,
          };
        case 11:
          return {
            min: 1000,
            max: 200000,
          };
        case 10:
          return {
            min: 20000,
            max: 50000000,
          };
        case 8:
          return {
            min: 1000,
            max: 5000000,
          };
        case 12:
          return {
            min: 10000,
            max: 150000000,
          };
        case 16:
          return {
            min: 10000,
            max: 150000000,
          };
        case 15:
          return {
            min: 10000,
            max: 50000000,
          };
        case 19:
          return {
            min: 100,
            max: 50000,
          };
        case 14:
          return {
            min: 1500,
            max: 5000000,
          };
        case 18:
          return {
            min: 100,
            max: 5000,
          };
        case 17:
          return {
            min: 80,
            max: 100000000,
          };
        case 20:
          return {
            min: 1000,
            max: 100000000,
          };
        case 21:
          return {
            min: 50,
            max: 500000,
          };
        case 22:
          return {
            min: 50000,
            max: 15000000,
          };
        case 23:
          return {
            min: 100,
            max: 350000,
          };
        default:
          return {
            min: 100,
            max: 100000000,
          };
      }
    },
    validation(category = 0, value) {
      const range = this.range(category);

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال السعر",
            en: "Please enter price",
          },
        };
      }
      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر مناسب",
            en: "Please enter appropriate price",
          },
        };
      }
      if (value > range.max) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر مناسب",
            en: "Please enter appropriate price",
          },
        };
      }

      return {
        error: false,
      };
    },
  },
  price_2_payments: {
    optional: true,

    name: {
      ar: "يقبل نصف سنوي",
      en: "Semi-annually",
    },
    secondaryName: { ar: "(ريال سعودي)", en: "(SAR)" },
    placeholder: "ادخل هنا...",
    type: "text-numeric",
    toggle: true,

    webType: "number",
    page: 2,
    order: 2,
    default: undefined,
    graphqlType: "Float",
    range(category = 0) {
      switch (category) {
        case 1:
          return {
            min: 50,
            max: 500000,
          };
        case 3:
          return {
            min: 50000,
            max: 100000000,
          };
        case 2:
          return {
            min: 1000,
            max: 10000000000,
          };
        case 5:
          return {
            min: 1000,
            max: 800000,
          };
        case 4:
          return {
            min: 1000,
            max: 300000,
          };
        case 6:
          return {
            min: 50000,
            max: 15000000,
          };
        case 7:
          return {
            min: 100000,
            max: 2000000000,
          };
        case 9:
          return {
            min: 50000,
            max: 5000000,
          };
        case 13:
          return {
            min: 100,
            max: 350000,
          };
        case 11:
          return {
            min: 1000,
            max: 200000,
          };
        case 10:
          return {
            min: 20000,
            max: 50000000,
          };
        case 8:
          return {
            min: 1000,
            max: 5000000,
          };
        case 12:
          return {
            min: 10000,
            max: 150000000,
          };
        case 16:
          return {
            min: 10000,
            max: 150000000,
          };
        case 15:
          return {
            min: 10000,
            max: 50000000,
          };
        case 19:
          return {
            min: 100,
            max: 50000,
          };
        case 14:
          return {
            min: 1500,
            max: 5000000,
          };
        case 18:
          return {
            min: 100,
            max: 5000,
          };
        case 17:
          return {
            min: 80,
            max: 100000000,
          };
        case 20:
          return {
            min: 1000,
            max: 100000000,
          };
        case 21:
          return {
            min: 50,
            max: 500000,
          };
        case 22:
          return {
            min: 50000,
            max: 15000000,
          };
        case 23:
          return {
            min: 100,
            max: 350000,
          };
        default:
          return {
            min: 100,
            max: 100000000,
          };
      }
    },
    validation(category = 0, value) {
      const range = this.range(category);

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال السعر",
            en: "Please enter price",
          },
        };
      }
      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر مناسب",
            en: "Please enter appropriate price",
          },
        };
      }
      if (value > range.max) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر مناسب",
            en: "Please enter appropriate price",
          },
        };
      }

      return {
        error: false,
      };
    },
  },
  width: {
    name: {
      ar: "العرض",
      en: "Width",
    },
    secondaryName: { ar: "(متر)", en: "(m)" },
    placeholder: "الرجاء كتابة العرض...",
    type: "text-numeric",
    webType: "number",
    page: 2,
    order: 2,
    default: undefined,
    graphqlType: "Float",
    range() {
      return {
        min: 1,
        max: 1000000000,
      };
    },
    validation(category = 0, value) {
      const range = this.range(category);

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال العرض",
            en: "Please enter price",
          },
        };
      }
      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال عرض مناسب",
            en: "Please enter appropriate price",
          },
        };
      }
      if (value > range.max) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال عرض مناسب",
            en: "Please enter appropriate price",
          },
        };
      }

      return {
        error: false,
      };
    },
  },
  length: {
    name: {
      ar: "طول",
      en: "length",
    },
    secondaryName: { ar: "(متر)", en: "(m)" },
    placeholder: "الرجاء كتابة طول...",
    type: "text-numeric",
    webType: "number",
    page: 2,
    order: 2,
    default: undefined,
    graphqlType: "Float",
    range() {
      return {
        min: 1,
        max: 1000000000,
      };
    },
    validation(category = 0, value) {
      const range = this.range(category);

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال طول",
            en: "Please enter price",
          },
        };
      }
      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال طول مناسب",
            en: "Please enter appropriate price",
          },
        };
      }
      if (value > range.max) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال طول مناسب",
            en: "Please enter appropriate price",
          },
        };
      }

      return {
        error: false,
      };
    },
  },
  meter_price: {
    // review - add validation
    name: {
      ar: "سعر المتر",
      en: "Meter price",
    },
    unit: "ريال",
    secondaryName: { ar: "(ريال سعودي)", en: "(SAR)" },
    placeholder: "الرجاء كتابة سعر المتر...",
    type: "text-numeric",
    webType: "number",
    called: {
      ar: "سعر المتر %s ريال",
    },
    range(category = 0) {
      switch (category) {
        default:
          return {
            min: 1,
            max: 1000000,
          };
      }
    },
    validation(category = 0, value) {
      const range = this.range(category);

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال سعر المتر",
            en: "Please enter meter price",
          },
        };
      }
      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: `يجب أن يكون سعر المتر أكبر من ${range.min}`,
            en: `wc should be more than ${range.min}`,
          },
        };
      }
      if (value > range.max) {
        return {
          error: true,
          message: {
            ar: `يجب أن يكون سعر المتر أصغر من ${range.max}`,
            en: `wc should be less than ${range.max}`,
          },
        };
      }
      return {
        error: false,
      };
    },
    page: 2,
    order: 1,
    default: undefined,
    graphqlType: "Float",
  },
  area: {
    // review - fix validation
    name: {
      ar: "المساحة",
      en: "Area",
    },
    icon: "v1/area",
    unit: "م\u00b2",
    secondaryName: { ar: "(متر مربع)", en: "(m2)" },
    placeholder: "الرجاء كتابة المساحة...",
    type: "text-numeric",
    webType: "number",
    range(category = 0) {
      switch (category) {
        case 1:
          return {
            min: 1,
            max: 10000,
          };
        case 3:
          return {
            min: 50,
            max: 15000,
          };
        case 2:
          return {
            min: 10,
            max: 10000000,
          };
        case 5:
          return {
            min: 100,
            max: 7000,
          };
        case 4:
          return {
            min: 1,
            max: 10000,
          };
        case 6:
          return {
            min: 20,
            max: 1000,
          };
        case 7:
          return {
            min: 100,
            max: 20000,
          };
        case 9:
          return {
            min: 50,
            max: 10000,
          };
        case 13:
          return {
            min: 50,
            max: 15000,
          };
        case 11:
          return {
            min: 50,
            max: 10000,
          };
        case 10:
          return {
            min: 50,
            max: 15000,
          };
        case 8:
          return {
            min: 2,
            max: 15000,
          };
        case 12:
          return {
            min: 100,
            max: 10000000,
          };
        case 16:
          return {
            min: 50,
            max: 20000,
          };
        case 15:
          return {
            min: 10,
            max: 10000000,
          };
        case 19:
          return {
            min: 1,
            max: 1000,
          };
        case 14:
          return {
            min: 20,
            max: 10000,
          };
        case 18:
          return {
            min: 20,
            max: 10000,
          };
        case 17:
          return {
            min: 10,
            max: 50000,
          };
        case 20:
          return {
            min: 2,
            max: 10000,
          };
        case 21:
          return {
            min: 1,
            max: 10000,
          };
        case 22:
          return {
            min: 20,
            max: 1000,
          };
        case 23:
          return {
            min: 50,
            max: 15000,
          };
        case 101:
          return {
            min: 1,
            max: 10000,
          };
        case 102:
          return {
            min: 50,
            max: 15000,
          };
        case 103:
          return {
            min: 20,
            max: 1000,
          };
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
          return {
            min: 50,
            max: 15000,
          };
        default:
          return {
            min: 0,
            max: 4,
            specialEnd: {
              ar: [{ key: 5, value: "5+" }],
              en: [{ key: 5, value: "5+" }],
            },
          };
      }
    },
    validation(category = 0, value) {
      const range = this.range(category);
      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال المساحة",
            en: "Please enter area",
          },
        };
      }

      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: `المساحة يجب أن تكون أكبر من ${range.min}`,
            en: `Area should be more than ${range.min}`,
          },
        };
      }
      if (value > range.max) {
        return {
          error: true,
          message: {
            ar: `المساحة يجب أن تكون أصغر من ${range.max}`,
            en: `Area should be less than ${range.max}`,
          },
        };
      }
      return {
        error: false,
      };
    },
    called: {
      ar: "المساحة %s متر مربع",
    },
    page: 2,
    order: 0,
    default: undefined,
    graphqlType: "Float",
  },
  street_direction: {
    icon: "v1/campass",
    name: {
      ar: "الواجهة",
      en: "Street direction",
    },
    type: "dropdown",
    webType: "taps",
    values: {
      ar: [
        "غير محدد",
        "شمال",
        "شرق",
        "غرب",
        "جنوب",
        "شمال شرقي",
        "جنوب شرقي",
        "جنوب غربي",
        "شمال غربي",
        "3 شوارع",
        "4 شوارع",
      ],
      en: [
        "Not Defined",
        "North",
        "East",
        "West",
        "South",
        "Northeast",
        "Southeast",
        "Southwest",
        "Northwest",
        "3 Streets",
        "4 Streets",
      ],
    },
    options: [
      { label: "شمالية", value: "1" },
      { label: "شرقية", value: "2" },
      { label: "غربية", value: "3" },
      { label: "جنوبية", value: "4" },
      { label: "شمالية شرقية", value: "5" },
      { label: "جنوبية شرقية", value: "6" },
      { label: "جنوبية غربية", value: "7" },
      { label: "شمالية غربية", value: "8" },
      { label: "ثلاث شوارع", value: "9" },
      { label: "أربع شوارع", value: "10" },
    ],
    // options: {
    //   ar: [
    //     { label: "شمالية", value: "1" },
    //     { label: "شرقية", value: "2" },
    //     { label: "غربية", value: "3" },
    //     { label: "جنوبية", value: "4" },
    //     { label: "شمالية شرقية", value: "5" },
    //     { label: "جنوبية شرقية", value: "6" },
    //     { label: "جنوبية غربية", value: "7" },
    //     { label: "شمالية غربية", value: "8" },
    //     { label: "ثلاث شوارع", value: "9" },
    //     { label: "أربع شوارع", value: "10" },
    //   ],
    //   en: [
    //     { label: "North", value: "1" },
    //     { label: "East", value: "2" },
    //     { label: "West", value: "3" },
    //     { label: "South", value: "4" },
    //     { label: "Northeast", value: "5" },
    //     { label: "Southeast", value: "6" },
    //     { label: "Southwest", value: "7" },
    //     { label: "Northwest", value: "8" },
    //     { label: "3 Streets", value: "9" },
    //     { label: "4 Streets", value: "10" },
    //   ],
    // },
    validation(category = 0, value) {
      if (!value || value === 0 || value > 10) {
        return {
          error: true,
          message: {
            ar: `الرجاء اختيار واجهة العقار`,
            en: `Please select a correct street direction`,
          },
        };
      }
      return {
        error: false,
      };
    },
    _value: true,
    _name: true,
    page: 1,
    order: 0,
    default: undefined,
    graphqlType: "Int",
  },
  beds: {
    icon: "v1/bed-king",
    name: {
      ar: "الغرف",
      en: "Bed rooms",
    },
    type: "slider",
    webType: "select-more",
    range() {
      return {
        min: 1,
        max: 6,
        specialEnd: {
          ar: [
            {
              key: 7,
              value: "7+",
            },
          ],
          en: [
            {
              key: 7,
              value: "7+",
            },
          ],
        },
      };
    },
    options: [
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
      { label: 6, value: 6 },
      { label: "7+", value: 7 },
    ],
    validation(category = 0, value) {
      const range = this.range();

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال عدد غرف النوم",
            en: "Please enter # of bedrooms",
          },
        };
      }

      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: `يجب أن يكون عدد غرف النوم أكبر من ${range.min}`,
            en: `#bedrooms should be more than ${range.min}`,
          },
        };
      }
      if (value > range.max + range.specialEnd.length) {
        return {
          error: true,
          message: {
            ar: `يجب أن يكون عدد غرف النوم أصغر من ${range.max}`,
            en: `#bedrooms should be less than ${range.max}`,
          },
        };
      }
      return {
        error: false,
      };
    },
    called: {
      ar: ["غرفة نوم", "غرفتا نوم", "غرف نوم"],
    },
    _max_five: true,
    page: 1,
    order: 9,
    default: 1,
    graphqlType: "Int",
  },
  apts: {
    name: {
      ar: "عدد الشقق",
      en: "Apartments",
    },
    type: "slider",
    webType: "select-more",
    range() {
      return {
        min: 0,
        max: 29,
        specialEnd: {
          ar: [
            {
              key: 30,
              value: "30+",
            },
          ],
          en: [
            {
              key: 30,
              value: "30+",
            },
          ],
        },
      };
    },
    options: [
      { label: "0", value: "0" },
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
      { label: 6, value: 6 },
      { label: 7, value: 7 },
      { label: 8, value: 8 },
      { label: 9, value: 9 },
      { label: 10, value: 10 },
      { label: 11, value: 11 },
      { label: 12, value: 12 },
      { label: 13, value: 13 },
      { label: 14, value: 14 },
      { label: 15, value: 15 },
      { label: 16, value: 16 },
      { label: 17, value: 17 },
      { label: 18, value: 18 },
      { label: 19, value: 19 },
      { label: 20, value: 20 },
      { label: 21, value: 21 },
      { label: 22, value: 22 },
      { label: 23, value: 23 },
      { label: 24, value: 24 },
      { label: 25, value: 25 },
      { label: 26, value: 26 },
      { label: 27, value: 27 },
      { label: 28, value: 28 },
      { label: 29, value: 29 },
      { label: "30+", value: 30 },
    ],
    called: {
      ar: ["شقة", "شقتان", "شقق"],
    },
    page: 1,
    order: 11,
    default: 0,
    graphqlType: "Int",
  },
  livings: {
    icon: "v1/couch",
    name: {
      ar: "الصالات",
      en: "Living rooms",
    },
    type: "slider",
    webType: "select-more",
    range() {
      return {
        min: 0,
        max: 6,
        specialEnd: {
          ar: [
            {
              key: 7,
              value: "7+",
            },
          ],
          en: [
            {
              key: 7,
              value: "7+",
            },
          ],
        },
      };
    },
    options: [
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
      { label: 6, value: 6 },
      { label: "7+", value: 7 },
    ],
    called: {
      ar: ["صالة", "صالتان", "صالات"],
    },
    _max_five: true,
    page: 1,
    order: 5,
    default: 1,
    graphqlType: "Int",
  },
  wc: {
    icon: "v1/path",
    name: {
      ar: "دورات المياه",
      en: "WC",
    },
    called: {
      ar: ["دورة مياه", "دورتا مياه", "دورات مياه"],
    },
    type: "slider",
    webType: "select-more",
    range(category = 0) {
      switch (category) {
        default:
          return {
            min: 0,
            max: 4,
            specialEnd: {
              ar: [{ key: 5, value: "5+" }],
              en: [{ key: 5, value: "5+" }],
            },
          };
      }
    },
    options: [
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: "5+", value: 5 },
    ],
    validation(category = 0, value) {
      const range = this.range(category);

      if (!value) {
        return {
          error: true,
          message: {
            ar: "الرجاء إدخال دورات المياه",
            en: "Please enter wc",
          },
        };
      }

      if (value < range.min) {
        return {
          error: true,
          message: {
            ar: `يجب أن يكون عدد دوراة المياه أكبر من ${range.min}`,
            en: `wc should be more than ${range.min}`,
          },
        };
      }
      if (value > 5) {
        return {
          error: true,
          message: {
            ar: `يجب أن يكون عدد دوراة المياه أصغر من ${range.max}`,
            en: `wc should be less than ${range.max}`,
          },
        };
      }
      return {
        error: false,
      };
    },
    page: 1,
    order: 6,
    default: 0,
    graphqlType: "Int",
  },
  street_width: {
    icon: "v1/street",
    // review
    unit: "م",
    name: {
      ar: "عرض الشارع",
      en: "Street width",
    },
    range(category) {
      switch (category) {
        default:
          return {
            min: 1,
            max: 100,
          };
      }
    },
    type: "slider",
    webType: "slider",
    options: [
      { label: "0م" },
      { label: "1م", value: 1 },
      { label: "2م", value: 2 },
      { label: "3م", value: 3 },
      { label: "4م", value: 4 },
      { label: "5م", value: 5 },
      { label: "6م", value: 6 },
      { label: "7م", value: 7 },
      { label: "8م", value: 8 },
      { label: "9م", value: 9 },
      { label: "10م", value: 10 },
      { label: "11م", value: 11 },
      { label: "12م", value: 12 },
      { label: "13م", value: 13 },
      { label: "14م", value: 14 },
      { label: "15م", value: 15 },
      { label: "16م", value: 16 },
      { label: "17م", value: 17 },
      { label: "18م", value: 18 },
      { label: "19م", value: 19 },
      { label: "20م", value: 20 },
      { label: "21م", value: 21 },
      { label: "22م", value: 22 },
      { label: "23م", value: 23 },
      { label: "24م", value: 24 },
      { label: "25م", value: 25 },
      { label: "26م", value: 26 },
      { label: "27م", value: 27 },
      { label: "28م", value: 28 },
      { label: "29م", value: 29 },
      { label: "30م", value: 30 },
      { label: "31م", value: 31 },
      { label: "32م", value: 32 },
      { label: "33م", value: 33 },
      { label: "34م", value: 34 },
      { label: "35م", value: 35 },
      { label: "36م", value: 36 },
      { label: "37م", value: 37 },
      { label: "38م", value: 38 },
      { label: "39م", value: 39 },
      { label: "40م", value: 40 },
      { label: "41م", value: 41 },
      { label: "42م", value: 42 },
      { label: "43م", value: 43 },
      { label: "44م", value: 44 },
      { label: "45م", value: 45 },
      { label: "50م", value: 50 },
      { label: "51م", value: 51 },
      { label: "52م", value: 52 },
      { label: "53م", value: 53 },
      { label: "54م", value: 54 },
      { label: "55م", value: 55 },
      { label: "56م", value: 56 },
      { label: "57م", value: 57 },
      { label: "58م", value: 58 },
      { label: "59م", value: 59 },
      { label: "60م", value: 60 },
      { label: "61م", value: 61 },
      { label: "62م", value: 62 },
      { label: "63م", value: 63 },
      { label: "64م", value: 64 },
      { label: "65م", value: 65 },
      { label: "66م", value: 66 },
      { label: "67م", value: 67 },
      { label: "68م", value: 68 },
      { label: "69م", value: 69 },
      { label: "70م", value: 70 },
      { label: "71م", value: 71 },
      { label: "72م", value: 72 },
      { label: "73م", value: 73 },
      { label: "74م", value: 74 },
      { label: "75م", value: 75 },
      { label: "76م", value: 76 },
      { label: "77م", value: 77 },
      { label: "78م", value: 78 },
      { label: "79م", value: 79 },
      { label: "80م", value: 80 },
      { label: "81م", value: 81 },
      { label: "82م", value: 82 },
      { label: "83م", value: 83 },
      { label: "84م", value: 84 },
      { label: "85م", value: 85 },
      { label: "86م", value: 86 },
      { label: "87م", value: 87 },
      { label: "88م", value: 88 },
      { label: "89م", value: 89 },
      { label: "90م", value: 90 },
      { label: "91م", value: 91 },
      { label: "92م", value: 92 },
      { label: "93م", value: 93 },
      { label: "94م", value: 94 },
      { label: "95م", value: 95 },
      { label: "96م", value: 96 },
      { label: "97م", value: 97 },
      { label: "98م", value: 98 },
      { label: "99م", value: 99 },
      { label: "100م", value: 100 },
    ],
    called: {
      ar: "عرض الشارع %s متر",
    },
    page: 1,
    order: 7,
    default: 5,
    graphqlType: "Int",
  },
  age: {
    name: {
      ar: "عمر العقار",
      en: "Age less than",
    },

    unit: "سنوات",
    type: "slider",
    webType: "select-more",
    called: {
      ar: ["سنة", "سنتين", "سنوات"],
    },
    range() {
      return {
        min: 1,
        max: 34,
        specialBeginning: {
          ar: [
            { key: 0, value: "جديد" },
            { key: -1, value: "غير محدد" },
          ],
          en: [
            { key: 0, value: "New" },
            { key: -1, value: "unknown" },
          ],
        },
        specialEnd: {
          ar: [
            {
              key: 35,
              value: "35+",
            },
          ],
          en: [
            {
              key: 35,
              value: "35+",
            },
          ],
        },
      };
    },
    options: [
      { label: "جديد", value: "0" },
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
      { label: 6, value: 6 },
      { label: 7, value: 7 },
      { label: 8, value: 8 },
      { label: 9, value: 9 },
      { label: 10, value: 10 },
      { label: 11, value: 11 },
      { label: 12, value: 12 },
      { label: 13, value: 13 },
      { label: 14, value: 14 },
      { label: 15, value: 15 },
      { label: 16, value: 16 },
      { label: 17, value: 17 },
      { label: 18, value: 18 },
      { label: 19, value: 19 },
      { label: 20, value: 20 },
      { label: 21, value: 21 },
      { label: 22, value: 22 },
      { label: 23, value: 23 },
      { label: 24, value: 24 },
      { label: 25, value: 25 },
      { label: 26, value: 26 },
      { label: 27, value: 27 },
      { label: 28, value: 28 },
      { label: 29, value: 29 },
      { label: 30, value: 30 },
      { label: 31, value: 31 },
      { label: 32, value: 32 },
      { label: 33, value: 33 },
      { label: 34, value: 34 },
      { label: "35+", value: 35 },
    ],
    _name: true,
    page: 1,
    order: 13,
    default: "0",
    graphqlType: "Int",
  },
  fl: {
    name: {
      ar: "الدور",
      en: "Floor",
    },
    type: "slider",
    webType: "select-more",
    range() {
      return {
        min: 3,
        max: 19,
        specialBeginning: {
          ar: [
            { key: 1, value: "أرضي" },
            { key: 2, value: "علوي" },
          ],
          en: [
            { key: 1, value: "Ground" },
            { key: 2, value: "Upper Ground" },
          ],
        },
        specialEnd: {
          ar: [{ key: 20, value: "20+" }],
          en: [{ key: 20, value: "20+" }],
        },
      };
    },
    options: [
      { label: "أرضي", value: 1 },
      { label: "علوي", value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
      { label: 6, value: 6 },
      { label: 7, value: 7 },
      { label: 8, value: 8 },
      { label: 9, value: 9 },
      { label: 10, value: 10 },
      { label: 11, value: 11 },
      { label: 12, value: 12 },
      { label: 13, value: 13 },
      { label: 14, value: 14 },
      { label: 15, value: 15 },
      { label: 16, value: 16 },
      { label: 17, value: 17 },
      { label: 18, value: 18 },
      { label: 19, value: 19 },
      { label: "20+", value: 20 },
    ],
    called: {
      ar: "الدور %s",
    },
    page: 1,
    order: 9,
    default: 1,
    graphqlType: "Int",
  },
  // men_place: {
  //     name: {
  //         ar: 'مجلس رجال',
  //         en: 'Men majles'
  //     },
  //     type: 'radio',
  //     values: {
  //         ar: ['لا يوجد', 'يوجد'],
  //         en: ['Not available', 'Available']
  //     },
  // },
  // women_place: {
  //     name: {
  //         ar: 'مجلس نساء',
  //         en: 'Women majles'
  //     },
  //     type: 'radio',
  //     values: {
  //         ar: ['لا يوجد', 'يوجد'],
  //         en: ['Not available', 'Available']
  //     }
  // },
  stores: {
    name: {
      ar: "عدد المحلات",
      en: "Stores",
    },
    type: "slider",
    webType: "slider",
    range() {
      return {
        min: 0,
        max: 50,
      };
    },
    options: [
      { label: "0", value: "0" },
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
      { label: 6, value: 6 },
      { label: 7, value: 7 },
      { label: 8, value: 8 },
      { label: 9, value: 9 },
      { label: 10, value: 10 },
      { label: 11, value: 11 },
      { label: 12, value: 12 },
      { label: 13, value: 13 },
      { label: 14, value: 14 },
      { label: 15, value: 15 },
      { label: 16, value: 16 },
      { label: 17, value: 17 },
      { label: 18, value: 18 },
      { label: 19, value: 19 },
      { label: 20, value: 20 },
      { label: 21, value: 21 },
      { label: 22, value: 22 },
      { label: 23, value: 23 },
      { label: 24, value: 24 },
      { label: 25, value: 25 },
      { label: 26, value: 26 },
      { label: 27, value: 27 },
      { label: 28, value: 28 },
      { label: 29, value: 29 },
      { label: 30, value: 30 },
      { label: 31, value: 31 },
      { label: 32, value: 32 },
      { label: 33, value: 33 },
      { label: 34, value: 34 },
      { label: 35, value: 35 },
      { label: 36, value: 36 },
      { label: 37, value: 37 },
      { label: 38, value: 38 },
      { label: 39, value: 39 },
      { label: 40, value: 40 },
      { label: 41, value: 41 },
      { label: 42, value: 42 },
      { label: 43, value: 43 },
      { label: 44, value: 44 },
      { label: 45, value: 45 },
      { label: 46, value: 46 },
      { label: 47, value: 47 },
      { label: 48, value: 48 },
      { label: 49, value: 49 },
      { label: 50, value: 50 },
    ],
    called: {
      ar: ["محل", "محلان", "محلات"],
    },
    page: 1,
    order: 14,
    default: "0",
    graphqlType: "Int",
  },
  rooms: {
    name: {
      ar: "عدد الغرف",
      en: "Rooms",
    },
    type: "slider",
    webType: "select-more",
    range(category) {
      switch (category) {
        case 7:
          return {
            min: 0,
            max: 100,
          };
        case 16:
          return {
            min: 0,
            max: 100,
          };
        default:
          return {
            min: 0,
            max: 5,
          };
      }
    },
    options: [
      { label: "0", value: "0" },
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
    ],
    getOptions(category) {
      const range = this.range(category);
      const options = [{ label: "0", value: "0" }];
      for (let i = range.min + 1; i <= range.max; i++) {
        options.push({ label: i, value: i });
      }
      return options;
    },
    called: {
      ar: ["غرفة نوم", "غرفتا نوم", "غرف نوم"],
    },
    _max_five: true,
    page: 1,
    order: 33,
    default: "0",
    graphqlType: "Int",
  },
  wells: {
    name: {
      ar: "عدد الآبار",
      en: "Wells",
    },
    type: "slider",
    webType: "select-more",
    range() {
      return {
        min: 0,
        max: 10,
      };
    },
    options: [
      { label: "0", value: "0" },
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
      { label: 6, value: 6 },
      { label: 7, value: 7 },
      { label: 8, value: 8 },
      { label: 9, value: 9 },
      { label: 10, value: 10 },
    ],
    validation(category, value) {
      return value > 99999999999
        ? { error: true, message: { ar: ``, en: `` } }
        : { error: false };
    },
    called: {
      ar: ["بئر", "بئران", "آبار"],
    },
    page: 1,
    order: 31,
    default: "0",
    graphqlType: "Int",
  },
  trees: {
    // review
    name: {
      ar: "عدد الأشجار",
      en: "Trees",
    },
    type: "slider",
    webType: "select-more",
    range() {
      return {
        min: 0,
        max: 10,
      };
    },
    options: [
      { label: "0", value: "0" },
      { label: 1, value: 1 },
      { label: 2, value: 2 },
      { label: 3, value: 3 },
      { label: 4, value: 4 },
      { label: 5, value: 5 },
      { label: 6, value: 6 },
      { label: 7, value: 7 },
      { label: 8, value: 8 },
      { label: 9, value: 9 },
      { label: 10, value: 10 },
    ],
    validation(category, value) {
      return value > 99999999999
        ? { error: true, message: { ar: ``, en: `` } }
        : { error: false };
    },
    called: {
      ar: ["شجرة", "شجرتان", "أشجار"],
    },
    page: 1,
    order: 32,
    default: "0",
    graphqlType: "Int",
  },
  type: {
    key: "type",
    name: {
      ar: "الغرض",
      en: "Residential and commercial",
    },
    type: "dropdown",
    specialType: "taps",
    webType: "select",
    options: [
      { label: "غير محدد", value: 0 },
      { label: "سكني", value: 1 },
      { label: "تجاري", value: 2 },
      { label: "تجاري وسكني", value: 3 },
    ],
    values: {
      ar: ["غير محدد", "سكني", "تجاري", "تجاري وسكني"],
      en: [
        "Not Defined",
        "Residential",
        "Commercial",
        "Residential & Commercial",
      ],
    },

    _value: true,
    page: 1,
    order: 3,
    default: "0",
    graphqlType: "Int",
  },
  family: {
    name: {
      ar: "الفئة",
      en: "Family or single",
    },
    type: "dropdown",
    webType: "select",
    values: {
      ar: ["غير محدد", "عزاب", "عوائل"],
      en: ["Not Defined", "Single", "Family"],
    },
    options: [
      { label: "غير محدد", value: 0 },
      { label: "عزاب", value: "0" },
      { label: "عوائل", value: "1" },
    ],
    specialType: "taps",
    _value: true,
    page: 1,
    order: -2,
    default: 1,
    graphqlType: "Int",
  },
  ketchen: {
    name: {
      ar: "مطبخ",
      en: "Kitchen",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 23,
    default: 1,
    graphqlType: "Int",
  },
  // duplex: {
  //   name: {
  //     ar: "دوبلكس",
  //     en: "Duplex",
  //   },
  //   type: "radio",
  //   webType: "bool",
  //   values: {
  //     ar: ["لا يوجد", "يوجد"],
  //     en: ["Not available", "Available"],
  //   },
  //   page: 1,
  //   order: 34,
  //   default: 0,
  //   graphqlType: "Int",
  // },
  furnished: {
    name: {
      ar: "مؤثثة",
      en: "Furnished",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 18,
    default: 0,
    graphqlType: "Int",
  },
  driver: {
    name: {
      ar: "غرفة سائق",
      en: "Driver room",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 15,
    default: 0,
    graphqlType: "Int",
  },
  maid: {
    name: {
      ar: "غرفة خادمة",
      en: "Maid room",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 16,
    default: 0,
    graphqlType: "Int",
  },
  basement: {
    name: {
      ar: "قبو",
      en: "Basement",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 29,
    default: 0,
    graphqlType: "Int",
  },
  lift: {
    name: {
      ar: "مصعد",
      en: "Lift",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 30,
    default: 0,
    graphqlType: "Int",
  },
  pool: {
    name: {
      ar: "مسبح",
      en: "Pool",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 17,
    default: 0,
    graphqlType: "Int",
  },
  stairs: {
    name: {
      ar: "درج صالة",
      en: "Stairs",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 10,
    default: 0,
    graphqlType: "Int",
  },
  fb: {
    name: {
      ar: "ملعب كرة قدم",
      en: "Football pitch",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 19,
    default: 0,
    graphqlType: "Int",
  },
  vb: {
    name: {
      ar: "ملعب كرة طائرة",
      en: "Volleyball Court",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 20,
    default: 0,
    graphqlType: "Int",
  },
  backyard: {
    name: {
      ar: "حوش",
      en: "Backyard",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 22,
    default: 0,
    graphqlType: "Int",
  },
  playground: {
    name: {
      ar: "ملاهي",
      en: "Playground",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 24,
    default: 0,
    graphqlType: "Int",
  },
  family_section: {
    name: {
      ar: "قسم عوائل",
      en: "Family section",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 1009,
    default: 0,
    graphqlType: "Int",
  },
  car_entrance: {
    name: {
      ar: "مدخل سيارة",
      en: "Car entrance",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 28,
    default: 0,
    graphqlType: "Int",
  },
  ac: {
    name: {
      ar: "مكيف",
      en: "Air conditioned",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 35,
    default: 0,
    graphqlType: "Int",
  },
  extra_unit: {
    name: {
      ar: "ملحق",
      en: "Extra unit",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 25,
    default: 0,
    graphqlType: "Int",
  },
  tent: {
    name: {
      ar: "بيت شعر",
      en: "Tent",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 21,
    default: 0,
    graphqlType: "Int",
  },
  water_availability: {
    name: {
      ar: "توفر الماء",
      en: "Water availability",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["غير متوفر", "متوفر"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 21,
    default: true,
    graphqlType: "Boolean",
  },
  electrical_availability: {
    name: {
      ar: "توفر  الكهرباء",
      en: "Electrical availability",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["غير متوفر", "متوفر"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 21,
    default: true,
    graphqlType: "Boolean",
  },
  private_roof: {
    name: {
      ar: "سطح خاص",
      en: "Private roof",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["غير متوفر", "متوفر"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 21,
    default: 0,
    graphqlType: "Boolean",
  },
  apartment_in_villa: {
    name: {
      ar: "في فيلا",
      en: "Apartment in villa",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["غير متوفر", "متوفر"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 21,
    default: 0,
    graphqlType: "Boolean",
  },
  two_entrances: {
    name: {
      ar: "مدخلين",
      en: "Two entrances",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["غير متوفر", "متوفر"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 21,
    default: 0,
    graphqlType: "Boolean",
  },
  special_entrance: {
    name: {
      ar: "مدخل خاص",
      en: "specia entrance",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["غير متوفر", "متوفر"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 21,
    default: 0,
    graphqlType: "Boolean",
  },
  drainage_availability: {
    name: {
      ar: "توفر الصرف",
      en: "Drainage Availability",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 23,
    default: true,
    graphqlType: "Boolean",
  },
  content: {
    name: {
      ar: "وصف العقار",
      en: "Description",
    },
    type: "text-input",
    webType: "text-area",
    placeholder: "الرجاء كتابة وصف عن العقار...",
    validation(category, value) {
      return true;
    },
    page: 2,
    order: 4,
    default: "",
    graphqlType: "String",
  },
  accept_monthly: {
    name: {
      ar: "دفع شهري",
      en: "Monthly Payments",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 23,
    default: 0,
    graphqlType: "Int",
  },
  accept_quarterly: {
    name: {
      ar: "دفع ربع سنوي",
      en: "Quarterly payment",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 23,
    default: 0,
    graphqlType: "Int",
  },
  accept_semiannually: {
    name: {
      ar: "دفع نصف سنوي",
      en: "Semiannually Payment",
    },
    type: "radio",
    webType: "bool",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 23,
    default: 0,
    graphqlType: "Int",
  },
};
